import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import GenericTwoFactorErrorAlert from '../alerts/GenericTwoFactorErrorAlert';
import BlockedLoginMethodAlert from '../alerts/BlockedLoginMethodAlert';
import InvalidCodeAlert from '../alerts/InvalidCodeAlert';
import NewCodeSentAlert from '../alerts/NewCodeSentAlert';
import SmsRateLimitAlert from '../alerts/SmsRateLimitAlert';
import RestrictedIpAddressAlert from '../alerts/RestrictedIpAddressAlert';
import ConfirmToLoginError from '../alerts/ConfirmToLoginError';
import HubspotAuthenticatorError from '../alerts/HubspotAuthenticatorError';
import NewCodeSentToEmailAlert from '../alerts/NewCodeSentToEmailAlert';
import TwoFactorAuthLevels from '../../constants/TwoFactorAuthLevels';
import TwoFactorAuthAppStates from '../../constants/TwoFactorAuthAppStates';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import ImageUrl from '../../images/imageUrls';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UILink from 'UIComponents/link/UILink';
// import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';

import UIFlex from 'UIComponents/layout/UIFlex';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Text } from 'foundations-components/components/Text';
import { Spacer } from 'foundations-components/components/Spacer';
import UIBox from 'UIComponents/layout/UIBox';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import Blob from '../../utils/Blob';
import { CONFIRM_TO_LOGIN_KEY, TWO_FACTOR_KEY } from '../../constants/CodeEntryKeyWords';
import { CANT_FIND_EMAIL_KB } from '../../constants/KnowledgeBaseUrls';
import UserDeactivatedAlert from '../alerts/UserDeactivatedAlert';
import { trackTwoFactorRecoveryMobileAuth } from '../../lib/tracker';
import HeaderWithLogo from '../shared/HeaderWithLogo';
// @ts-expect-error no types from package
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RECOVERY_REASONS = ['new', 'lost', 'uninstalled'];
const validatingProps = (keyWord, type) => {
  return (props, propName, componentName) => {
    if (props.keyWord !== keyWord) {
      return null;
    }
    if (typeof props[propName] === type) {
      return null;
    }
    return new Error(`Invalid prop ${propName} passed to ${componentName}. Expected ${propName} to be a ${type}.`);
  };
};
export default class CodeEntryForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderCodeEntry = () => {
      if (this.props.keyWord === TWO_FACTOR_KEY && this.props.isHubspotAuthenticator && this.props.appState !== TwoFactorAuthAppStates.BACKUP) {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(AccordionItem, {
            title: /*#__PURE__*/_jsx(UILink, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "login.twoFactor.questionHubspotApp"
              })
            }),
            marginBlockStart: "700",
            children: [/*#__PURE__*/_jsx(Text, {
              marginBlockStart: "500",
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "login.twoFactor.descriptionHubspotApp"
              })
            }), /*#__PURE__*/_jsxs(UIFlex, {
              direction: "row",
              wrap: "wrap",
              align: "end",
              justify: "between",
              children: [/*#__PURE__*/_jsx(UIBox, {
                basis: 300,
                shrink: 0,
                children: this.renderImage()
              }), /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs(View, {
                  inlineSize: "200px",
                  marginBlockEnd: "400",
                  children: [/*#__PURE__*/_jsx(UIFormLabel, {
                    htmlFor: "code",
                    children: I18n.text(`login.${this.props.keyWord}.inputLabel`)
                  }), /*#__PURE__*/_jsx(UITextInput, {
                    autoFocus: true,
                    id: "code",
                    onChange: this.props.onCodeChange
                    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
                    ,
                    tabIndex: "1",
                    maxLength: this.props.codeLength,
                    value: this.props.inputValue,
                    disabled: this.props.isVerifying || this.props.isRequestingCode
                  })]
                }), this.props.renderSubmitButton(), /*#__PURE__*/_jsx(Spacer, {
                  space: "200"
                })]
              })]
            }), /*#__PURE__*/_jsx(Spacer, {}), this.renderLostDeviceTile()]
          })
        });
      } else {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIFormLabel, {
            htmlFor: "code",
            children: I18n.text(`login.${this.props.keyWord}.inputLabel`)
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "200px",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(UITextInput, {
              autoFocus: true,
              id: "code",
              onChange: this.props.onCodeChange
              // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
              ,
              tabIndex: "1",
              maxLength: this.props.codeLength,
              value: this.props.inputValue,
              disabled: this.props.isVerifying || this.props.isRequestingCode
            })
          })]
        });
      }
    };
    this.renderLostDeviceTile = () => {
      const {
        onLostDevice
      } = this.props;
      const onClickLostDeviceHandler = reason => {
        if (onLostDevice) {
          trackTwoFactorRecoveryMobileAuth(reason);
          onLostDevice();
        }
      };
      const divider = /*#__PURE__*/_jsx(View, {
        paddingInline: "300",
        children: "|"
      });
      return /*#__PURE__*/_jsxs(UITile, {
        compact: true,
        children: [/*#__PURE__*/_jsxs(UITileSection, {
          children: [/*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `login.twoFactor.mobileAppLostDevice.title`
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: `login.twoFactor.mobileAppLostDevice.body`
          })]
        }), /*#__PURE__*/_jsx(UITileSection, {
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: "row",
            flexWrap: "wrap",
            children: RECOVERY_REASONS.map((reason, key) => {
              return /*#__PURE__*/_jsxs(Flex, {
                flexDirection: "row",
                children: [key !== 0 && divider, /*#__PURE__*/_jsx(UIButton, {
                  use: "link",
                  onClick: () => {
                    onClickLostDeviceHandler(reason);
                  },
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: `login.twoFactor.mobileAppRecovery.${reason}`
                  })
                })]
              }, key);
            })
          })
        })]
      });
    };
    this.renderSmsRetry = () => {
      if (this.props.keyWord !== TWO_FACTOR_KEY) {
        return null;
      }
      const {
        retryCode
      } = this.props;
      if (!this.props.shouldRenderFooter) {
        return null;
      }
      const smsRetry = this.props.isSms && /*#__PURE__*/_jsx("a", {
        onClick: retryCode,
        children: I18n.text('login.twoFactor.phoneAuth.newCode')
      });
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("p", {
          children: smsRetry
        })
      });
    };
    this.renderAlerts = () => {
      const {
        keyWord,
        error,
        newCodeSentAlertVisible,
        dismissNewCodeSentAlert,
        email,
        vettingUrl
      } = this.props;
      switch (keyWord) {
        case TWO_FACTOR_KEY:
          return [/*#__PURE__*/_jsx(GenericTwoFactorErrorAlert, {}, 1), /*#__PURE__*/_jsx(InvalidCodeAlert, {}, 2), /*#__PURE__*/_jsx(NewCodeSentAlert, {}, 3), /*#__PURE__*/_jsx(SmsRateLimitAlert, {}, 4), /*#__PURE__*/_jsx(UserDeactivatedAlert, {}, 5), /*#__PURE__*/_jsx(BlockedLoginMethodAlert, {}, 6), /*#__PURE__*/_jsx(RestrictedIpAddressAlert, {}, 7)];
        case CONFIRM_TO_LOGIN_KEY:
          return [/*#__PURE__*/_jsx(ConfirmToLoginError, {
            error: error,
            keyWord: keyWord,
            vettingUrl: vettingUrl
          }, 7), /*#__PURE__*/_jsx(NewCodeSentToEmailAlert, {
            newCodeSentAlertVisible: newCodeSentAlertVisible,
            dismissNewCodeSentAlert: dismissNewCodeSentAlert,
            email: email,
            keyWord: keyWord
          }, 8)];
        default:
          return null;
      }
    };
    this.renderRecoveryLink = () => {
      const {
        keyWord,
        onLostDevice,
        isHubspotAuthenticator
      } = this.props;
      if (keyWord !== TWO_FACTOR_KEY || isHubspotAuthenticator) {
        return null;
      }
      return /*#__PURE__*/_jsx("a", {
        "data-test-id": "2fa-lost-device-button",
        onClick: onLostDevice,
        children: I18n.text('login.twoFactor.lostDevice')
      });
    };
    this.renderFooter = () => {
      const {
        switchVerificationMethod,
        hasSecondaryMethod,
        twoFactorLevel,
        switchAppState,
        appState,
        backupCodesEnabled,
        areBothGoogleAuth,
        keyWord,
        isSms,
        callForCode
      } = this.props;
      if (keyWord !== TWO_FACTOR_KEY) {
        return null;
      }
      if (!this.props.shouldRenderFooter) {
        return /*#__PURE__*/_jsx("div", {
          children: this.renderRecoveryLink()
        });
      }
      let switchMethods;
      let backupCode;
      let switchToPrimary;
      let switchToSecondary;
      if (appState === TwoFactorAuthAppStates.DEFAULT && switchAppState) {
        const backupVerificationMethodMessage = twoFactorLevel === TwoFactorAuthLevels.PRIMARY ? I18n.text('login.twoFactor.secondary') : I18n.text('login.twoFactor.primary');
        switchMethods = hasSecondaryMethod && !areBothGoogleAuth && /*#__PURE__*/_jsx("a", {
          "data-test-id": "switch-2fa-verification-method-button",
          onClick: switchVerificationMethod,
          children: backupVerificationMethodMessage
        });
        backupCode = backupCodesEnabled && /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState();
          },
          children: I18n.text('login.twoFactor.backupCode.footer')
        });
      } else if (switchAppState) {
        switchToPrimary = /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState(TwoFactorAuthLevels.PRIMARY);
          },
          children: I18n.text('login.twoFactor.primary')
        });
        switchToSecondary = hasSecondaryMethod && /*#__PURE__*/_jsx("a", {
          onClick: () => {
            switchAppState(TwoFactorAuthLevels.SECONDARY);
          },
          children: I18n.text('login.twoFactor.secondary')
        });
      }
      const callForTheCode = isSms && callForCode ? /*#__PURE__*/_jsx("a", {
        onClick: () => {
          callForCode();
        },
        children: I18n.text('login.twoFactor.phoneAuth.callForCode')
      }) : null;
      return /*#__PURE__*/_jsxs(View, {
        marginBlock: "400",
        children: [I18n.text('login.twoFactor.footerQuestion'), /*#__PURE__*/_jsx(Spacer, {
          space: "200"
        }), /*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          children: [callForTheCode, switchMethods, backupCode, switchToPrimary, switchToSecondary, this.renderRecoveryLink()]
        })]
      });
    };
    this.renderGetNewCode = () => {
      const {
        keyWord,
        onGetNewCode
      } = this.props;
      if (keyWord !== CONFIRM_TO_LOGIN_KEY || !onGetNewCode) {
        return null;
      }
      return /*#__PURE__*/_jsx(View, {
        marginBlock: "600",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: onGetNewCode,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.confirmToLogin.newCode"
          })
        })
      });
    };
    this.renderTroubleshootLink = () => {
      const {
        keyWord
      } = this.props;
      if (keyWord !== CONFIRM_TO_LOGIN_KEY) {
        return null;
      }
      return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: CANT_FIND_EMAIL_KB,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.confirmToLogin.troubleshoot"
        })
      });
    };
    this.renderImage = () => {
      return /*#__PURE__*/_jsx(Image, {
        src: ImageUrl.hubspotMobileApp,
        alt: "Hubspot App Screen",
        marginBlockStart: "400"
      });
    };
    this.renderSubmit = () => {
      if (this.props.keyWord === TWO_FACTOR_KEY) {
        if (!this.props.isHubspotAuthenticator || this.props.appState === TwoFactorAuthAppStates.BACKUP) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    };
  }
  render() {
    const keyWord = this.props.keyWord;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(HeaderWithLogo, {
        logoWidth: "128px",
        logoAlignment: "start",
        logoPadding: "300",
        children: /*#__PURE__*/_jsx(UIBackButton, {
          children: /*#__PURE__*/_jsx(UILink, {
            onClick: this.props.onReturnToLogin,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "login.confirmToLogin.loginReturn"
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        flexWrap: "wrap",
        padding: "1400",
        children: [/*#__PURE__*/_jsx(UIBox, {
          basis: 545,
          shrink: 1,
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h1", {
                children: this.props.header
              }), /*#__PURE__*/_jsx(HubspotAuthenticatorError, {
                restartTimer: this.props.onRestartTimer
              }), /*#__PURE__*/_jsx("p", {
                children: this.props.description
              }), this.renderTroubleshootLink()]
            }), /*#__PURE__*/_jsxs("form", {
              id: "hs-login",
              onSubmit: this.props.onSubmit,
              children: [this.renderCodeEntry(), this.renderGetNewCode(), this.renderSmsRetry(), /*#__PURE__*/_jsx(View, {
                marginBlock: "600",
                children: this.renderAlerts()
              }), this.renderSubmit() && this.props.renderSubmitButton()]
            }), this.renderFooter()]
          })
        }), /*#__PURE__*/_jsx(UIBox, {
          basis: 150
        }), /*#__PURE__*/_jsx(UIBox, {
          children: /*#__PURE__*/_jsxs(Text, {
            textAlign: "center",
            children: [/*#__PURE__*/_jsx(Blob, {
              renderComponent: this.props.renderIllustration
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                children: I18n.text(`login.${keyWord}.explanationText`)
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `login.${keyWord}.knowledgeBase`
                })
              })]
            })]
          })
        })]
      })]
    });
  }
}
CodeEntryForm.propTypes = {
  areBothGoogleAuth: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  appState: validatingProps(TWO_FACTOR_KEY, 'string'),
  backupCodesEnabled: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  description: PropTypes.element,
  codeLength: PropTypes.number.isRequired,
  hasSecondaryMethod: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  header: PropTypes.element.isRequired,
  inputValue: PropTypes.string.isRequired,
  isRequestingCode: PropTypes.bool.isRequired,
  isSms: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  isHubspotAuthenticator: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  isVerifying: PropTypes.bool.isRequired,
  keyWord: PropTypes.string.isRequired,
  onCodeChange: PropTypes.func.isRequired,
  onLostDevice: validatingProps(TWO_FACTOR_KEY, 'function'),
  onReturnToLogin: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  renderIllustration: PropTypes.func.isRequired,
  renderSubmitButton: PropTypes.func.isRequired,
  retryCode: validatingProps(TWO_FACTOR_KEY, 'function'),
  callForCode: validatingProps(TWO_FACTOR_KEY, 'function'),
  switchAppState: validatingProps(TWO_FACTOR_KEY, 'function'),
  switchVerificationMethod: validatingProps(TWO_FACTOR_KEY, 'function'),
  twoFactorLevel: validatingProps(TWO_FACTOR_KEY, 'string'),
  dismissNewCodeSentAlert: validatingProps(CONFIRM_TO_LOGIN_KEY, 'function'),
  email: PropTypes.string,
  error: PropTypes.string,
  newCodeSentAlertVisible: validatingProps(CONFIRM_TO_LOGIN_KEY, 'boolean'),
  onGetNewCode: validatingProps(CONFIRM_TO_LOGIN_KEY, 'function'),
  shouldRenderFooter: validatingProps(TWO_FACTOR_KEY, 'boolean'),
  onRestartTimer: validatingProps(TWO_FACTOR_KEY, 'function')
};